import React from 'react';
import '../styles/LicenseExpired.css';

const LicenseExpired = ({ licenseStatus }) => {
    const getStatusTitle = () => {
        const status = licenseStatus?.licenseStatus;
        if (status === 'expired') return 'License Expired';
        if (status === 'suspended') return 'License Suspended';
        if (status === 'revoked') return 'License Revoked';
        if (status === 'invalid') return 'Invalid License';
        if (status === 'error') return 'License Verification Error';
        return 'License Issue';
    };

    const getStatusIcon = () => {
        const status = licenseStatus?.licenseStatus;
        if (status === 'error') return '⚠️';
        if (status === 'suspended' || status === 'revoked') return '🚫';
        return '🔒';
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            return new Date(dateString).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        } catch {
            return 'N/A';
        }
    };

    return (
        <div className="license-expired-container">
            <div className="license-expired-box">
                <div className="license-expired-icon">
                    {getStatusIcon()}
                </div>

                <h1>{getStatusTitle()}</h1>

                <p className="license-message">
                    {licenseStatus?.message || 'Your POS license is not active. Please contact support.'}
                </p>

                {licenseStatus?.subscription && (
                    <div className="license-details">
                        {licenseStatus.subscription.endDate && (
                            <p>
                                <strong>Subscription ended:</strong> {formatDate(licenseStatus.subscription.endDate)}
                            </p>
                        )}
                        {licenseStatus.subscription.graceEndDate && (
                            <p className="grace-info">
                                <strong>Grace period ends:</strong> {formatDate(licenseStatus.subscription.graceEndDate)}
                            </p>
                        )}
                        {licenseStatus.subscription.type && (
                            <p>
                                <strong>Subscription type:</strong> {licenseStatus.subscription.type}
                            </p>
                        )}
                    </div>
                )}

                <div className="contact-support">
                    <h3>Contact Support to Renew</h3>
                    {licenseStatus?.supportContact ? (
                        <>
                            {licenseStatus.supportContact.email && (
                                <p>
                                    <strong>Email:</strong>{' '}
                                    <a href={`mailto:${licenseStatus.supportContact.email}`}>
                                        {licenseStatus.supportContact.email}
                                    </a>
                                </p>
                            )}
                            {licenseStatus.supportContact.phone && (
                                <p>
                                    <strong>Phone:</strong> {licenseStatus.supportContact.phone}
                                </p>
                            )}
                        </>
                    ) : (
                        <p>
                            <strong>Email:</strong>{' '}
                            <a href="mailto:support@yourcompany.com">support@yourcompany.com</a>
                        </p>
                    )}
                </div>

                <button
                    onClick={() => window.location.reload()}
                    className="retry-btn"
                >
                    Retry Verification
                </button>
            </div>
        </div>
    );
};

export default LicenseExpired;
